import React from 'react';
import { CombinationGroups } from './Combination/CombinationGroups';
import { SegmentGroups } from './SegmentGroups';

interface ComposedProps {}


export const SaviIntlGroups: React.FunctionComponent<ComposedProps> = ({
}) => {
  return (
    <div>
      {/* For Flight */}
      <CombinationGroups />
      {/* For Hotel and Car */}
      <SegmentGroups />
    </div>
  );
}